<template><div></div></template>
<script setup lang="ts">
  import { useLoginState } from '@/composables/store/useLoginStore';
  import { UserRepository } from '@/features/user/api/userRepository';

  const { userId } = useLoginState();
  const repository = UserRepository();

  watch(
    userId,
    async (newUserId) => {
      // 初期値（0）や無効な値は除外
      if (!newUserId || newUserId === 0) return;
      await repository.registerDeviceInfo();
    },
    { immediate: true },
  );
</script>
